export default __webpack_public_path__ + "static/media/TitilliumWeb-Italic.2531c8e3.ttf";